import styled from '@emotion/styled';
import { ReactComponent as LockIcon } from '../ui/icons/Cadenas.svg';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { SubscriptionButtonWithIcon, WhiteButton } from '../ui/Button';

interface SubscriptionModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  text: string;
  link: string;
}

const Close = styled.p`
    width: 100%;
    text-align: center;
    color: var(--grey);
    text-decoration: underline;
    font-size: 14px;
    cursor: pointer;
    :hover {
      font-weight: bold;
    }
  }
`;

const SubscriptionModal = ({
  open,
  onClose,
  title,
  text,
  link,
}: SubscriptionModalProps) => {
  const { t } = useTranslation(['common']);
  const { enqueueSnackbar } = useSnackbar();

  const handleKnowMore = () => {
    window.open(link, '_blank');
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        padding="16px"
        px={3}
      >
        <DialogTitle>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap={1}
          >
            <LockIcon style={{ color: 'black', width: "24px", height: "24px" }} />
            <Typography variant="h6" fontWeight="bold">
              {t('common:subscription.teasingModal.title')}
            </Typography>
          </Box>
        </DialogTitle>

        <DialogContent>
          <Typography variant="subtitle1">{text}</Typography>
        </DialogContent>
        <DialogActions sx={{ flexDirection: 'column', gap: 1, width: '100%' }}>
          <SubscriptionButtonWithIcon
            href="/checkout"
            fullWidth
            sx={{ margin: '0 !important' }}
          >
            {t('common:subscription.presentationPage.subscriptionButton')}
          </SubscriptionButtonWithIcon>
          <WhiteButton
            onClick={handleKnowMore}
            fullWidth
            sx={{ margin: '0 !important' }}
          >
            {t('common:subscription.presentationPage.knowMoreButton')}
          </WhiteButton>
          <Close onClick={onClose}>{t('common:cancel')}</Close>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default SubscriptionModal;
